module.exports = __webpack_public_path__ + "public/Icons/Chat-icon.png?d166ed3c";